import { IntlInstance } from 'src/migration/react-intl';

export const userInputError = (value: string, intl: IntlInstance): string | null => {
  if (value.length < 3) {
    return intl.formatMessage({ id: 'shareProject/modal/input/validation/length' }, { value });
  }

  const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!EMAIL_REGEXP.test(value)) {
    return intl.formatMessage({ id: 'shareProject/modal/input/validation/email' }, { value });
  }

  return null;
};
